module.exports = __webpack_public_path__ + "88b3d9b8984bb16f3705c3be7d1e438c.svg";